export const COORDS = {
  agenziaData:   { x: 536, y: 735 },  // data creazione (in basso a dx sotto logo)
  nominativo:  { x: 536,  y: 670 },
  cf_piva:     { x: 536,  y: 630 },
  targa:   { x: 385,  y: 531 },
  pacchetto:   { x: 184,  y: 472 },
};